import {userConstants} from '../Constant';
import {alertActions} from '../Actions';
import {HistoryManager} from '../../history-manager';
import {UserModelManager} from '../UserModelManager';
import {SessionManager} from '../../session-manager';


export const userActions = {
  login,
  logout,
  getConnectedUser,
  reconnect,
};

function getConnectedUser(slug = null) {
  return dispatch => {
    UserModelManager.getConnectedUser(slug)
      .then(
        user => {
          dispatch(success(user));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function success(user) {
    return {type: userConstants.GETCONNECTEDUSER_SUCCESS, user}
  }

  function failure(error) {
    return {type: userConstants.GETCONNECTEDUSER_FAILURE, error}
  }
}

function reconnect() {
  return dispatch => {
    SessionManager.setExpired(true);
    dispatch({type: userConstants.RECONNECT});
  };
}

function login(username, password, slug = null) {
  return dispatch => {
    dispatch(request({username}));
    UserModelManager.login(username, password, slug)
      .then(
        user => {
          dispatch(success(user));
          const currentLocation = HistoryManager.getHistory().location.pathname;
          if (currentLocation === '/login') {
            HistoryManager.getHistory().push('/');
          } else {
            window.location.reload();
          }
        },
        error => {
          dispatch(failure(error));
          if (SessionManager.isExpired()) {
            dispatch({type: userConstants.RECONNECT});
          }
          dispatch(alertActions.error('Email ou mot de passe incorrect'));
        }
      );
  };

  function request(user) {
    return {type: userConstants.LOGIN_REQUEST, user}
  }

  function success(user) {
    return {type: userConstants.LOGIN_SUCCESS, user}
  }

  function failure(error) {
    return {type: userConstants.LOGIN_FAILURE, error}
  }
}

function logout() {
  return dispatch => {
    dispatch({type: userConstants.LOGOUT});
    SessionManager.logout();
    HistoryManager.getHistory().push('/login');
  };
}